import resolver, {ResolverSettings} from './utils/resolver';

class ValidatorApi {
  ENDPOINTS = {
    phoneNumber: () => `validators/phone-number`,
    getPurposeOfStay: (params = '') => `purposes-of-stay/?${params}`,
  };

  async validatePhoneNumber(
    payload: {phone: string},
    resolverSettings?: ResolverSettings,
  ) {
    const response = await resolver(
      this.ENDPOINTS.phoneNumber(),
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      resolverSettings,
    );
    return response.body;
  }

  async getPurposeOfStay(resolverSettings?: ResolverSettings) {
    const response = await resolver<{id: string; name: string}[]>(
      this.ENDPOINTS.getPurposeOfStay(),
      null,
      resolverSettings,
    );
    return response.body;
  }
}

export {ValidatorApi};
